<template>
  <CategoryPage />
</template>

<script setup lang="ts">
import CategoryPage from '@st/casino/components/CategoryPage/CategoryPage.vue'

definePageMeta({
  layout: 'casino-page',
})

useSeoData('casino-subcategory')
</script>
